import { Cell, Grid, Heading, HFlow } from 'bold-ui'
import { EnderecoFieldGroup, RadioGroupField } from 'components/form'
import { EnderecoIndigenaFieldGroup } from 'components/form/field/enderecoindigena/EnderecoIndigenaFieldGroup'
import { InfoIcon } from 'components/InfoIcon'
import { FormRenderProps } from 'react-final-form'
import { MetaRoot } from 'util/metaPath'
import { tipoEnderecoOptions } from 'view/cadastro-imovel/model-cadastroImovel'

import { CidadaoFormModel } from '../types/model-cidadao'

interface EnderecoFormSectionProps {
  meta: MetaRoot<CidadaoFormModel>
  formProps: FormRenderProps<CidadaoFormModel>
  values: CidadaoFormModel
  isCidadaoAldeado: boolean
  isEnderecoIndigena: boolean
}

export const EnderecoFormSection = (props: EnderecoFormSectionProps) => {
  const { meta, formProps, values, isCidadaoAldeado, isEnderecoIndigena } = props

  return (
    <Grid>
      <Cell size={12}>
        {isCidadaoAldeado ? (
          <Heading level={2}>Localização</Heading>
        ) : (
          <HFlow hSpacing={0.5} alignItems='center'>
            <Heading level={2}>Residência</Heading>
            <InfoIcon icon='infoCircleFilled' text='Não substitui o cadastro completo de imóvel e família.' />
          </HFlow>
        )}
      </Cell>
      {isCidadaoAldeado && (
        <Cell size={12}>
          <RadioGroupField label='Localidade' name={meta.tipoEndereco} options={tipoEnderecoOptions} required />
        </Cell>
      )}
      {!isEnderecoIndigena ? (
        <Cell size={12}>
          <EnderecoFieldGroup
            name={meta.endereco}
            formProps={formProps}
            formModelValue={values}
            renderPais
            isCidadaoAldeado={isCidadaoAldeado}
            renderTipoLogradouro
          />
        </Cell>
      ) : (
        <Cell size={12}>
          <EnderecoIndigenaFieldGroup
            name={meta.enderecoIndigena}
            formProps={formProps}
            formModelValue={values}
            isCadastroCidadao
          />
        </Cell>
      )}
    </Grid>
  )
}
